<template>
  <div class="sela-logo">
    <img class="" src="@/assets/deco/crown.png" />
  </div>
</template>
<script>
export default {}
</script>
<style></style>
